import {MessageBase} from './message-base';
import {DataRow} from '../DoraData/data-row';

export class MessageLevelSelected  extends MessageBase<MessageLevelSelected> {
  // tslint:disable-next-line:variable-name
  private _dataRow: DataRow;

  constructor(dataRow: DataRow) {
    super(MessageLevelSelected);

    this._dataRow = dataRow;
  }

  public get dataRow(): DataRow {
    return this._dataRow;
  }
}
